/**
 * Function to render Spark View templates
 *
 * A template location and various data is passed to the function.
 * To make the Spark views work for both server and client, we have
 * created a naming convention where the model name inside views is the same
 * as the view itself.
 *
 * A 'dataName' is generated based on the template name and the 'data' is set
 * as the value of that key within the new 'dataObj' object.
 *
 * This 'dataObj' is then extend with any 'additionalData'. This allows us to pass
 * extra variables to the template that would have been naturally been inherited when
 * the view is processed in C#
 *
 * @param  {string} templateLocation [Location of the template in the shared directory]
 * @param  {object} data             [Data for the view]
 * @param  {object} additionalData   [Additional data extend with the 'dataObj' object]
 * @return {string}                  [Rendered HTML]
 */

OT.createNS('OT.Search.Helpers.renderTemplate');

OT.Search.Helpers.renderTemplate = function(templateLocation, data, additionalData) {

    var path         = window.Spark.Shared;
    var folders      = templateLocation.split('/');
    var firstLetter  = templateLocation.charAt(templateLocation.indexOf('_') + 1).toLowerCase();
    var templateName = folders[folders.length - 1];
    var dataName     = firstLetter + templateName.substring(2);
    var dataObj      = {};

    // Set the data object's name and data based on the template name
    dataObj[dataName] = data;

    // Add any additional data to the dataObj
    if(additionalData) {
        _.extend(dataObj, additionalData);
    }

    // remove the template name from the folders array
    folders.pop();

    _.each(folders, function(folder) {
        path = path[folder];
    });

    if(path !== undefined && path[templateName]) {
        return path[templateName].RenderView(dataObj);
    }
};
